import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "language-switcher"
}
const _hoisted_2 = ["onClick"]


import { useI18n } from "vue-i18n";
import { setLocale, type SupportedLocale } from "@/i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageSwitcher',
  props: {
  isVisible: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {



const { locale } = useI18n();

const localeOptions: { label: string; value: SupportedLocale }[] = [
  { label: "RU", value: "ru" },
  { label: "EN", value: "en" },
];

const changeLocale = (nextLocale: SupportedLocale) => {
  setLocale(nextLocale);
};

return (_ctx: any,_cache: any) => {
  return (__props.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(localeOptions, (item) => {
          return _createElementVNode("button", {
            key: item.value,
            type: "button",
            class: _normalizeClass(["language-switcher__button caption-small--bold", { active: _unref(locale) === item.value }]),
            onClick: ($event: any) => (changeLocale(item.value))
          }, _toDisplayString(item.label), 11, _hoisted_2)
        }), 64))
      ]))
    : _createCommentVNode("", true)
}
}

})